export default __webpack_public_path__ + "static/media/feedback_correct_02.f9f93e20.png";